import styled from 'styled-components';
import { TIPOTEXTO_ENUM } from '../../modules/Helper/tipoTextoEnum';

export const Container = styled.div`
  padding: 0 20px;
  height: 100%;
  background: ${({ fundoTransparente }) =>
    fundoTransparente ? 'transparent' : 'rgba(255, 255, 255, 0.9)'};
  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  word-wrap: break-word;
  white-space: normal;
  width: 100%;
  height: auto;

  span {
    ${({ tipoTexto }) =>
      tipoTexto === TIPOTEXTO_ENUM.TITULO &&
      `
        font-size: 1rem;

        @media (max-width: 1024px) {
          font-size: 1.4rem !important;
        }

        @media (max-width: 768px) {
          font-size: 1.2rem !important;
        }

        @media (max-width: 480px) {
          font-size: 1rem !important;
        }
      `}
  }
`;

